import { IDeltaUserSettings, IUserTrackingData, ResearchSelectionType } from '@/interfaces/deltaGpt/IDeltaUserSettings.ts';

export const DEFAULT_SPARK_SITE_SETTINGS: IDeltaUserSettings = {
    isDarkMode: true,
    showMyProducts: null,
    researchSelection: ResearchSelectionType.AllProducts,
    researchSearchSelection: ResearchSelectionType.AllProducts,
    recentSearches: [],
    pinnedSearches: [],
    pinnedSearchCategories: [],
    likedResearchIds: [],
    interestAreas: [],
};

export const DEFAULT_USER_TRACKING_DATA: IUserTrackingData = {
    viewedDocumentShortCodes: [],
    feedVisitState: {
        yourFeedLastVisitedAt: null,
        allFeedLastVisitedAt: null,
        sectionFeedLastVisitedAtByRouteName: {},
        attentionDismissedAt: null,
    },
};
